export default __webpack_public_path__ + "static/media/WKAVA.6f90df37.png";